import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGovBuilding = () => {
  return (
    <g>
      <path d="M15.143 14.5c.41 0 .744.336.744.75s-.333.75-.744.75H.746a.747.747 0 0 1-.744-.75c0-.414.333-.75.744-.75h14.397zM11.17 6h1.49v6h.992c.411 0 .745.336.745.75s-.334.75-.745.75H2.235a.747.747 0 0 1-.744-.75c0-.414.333-.75.744-.75h.993V6h1.49v6H7.2V6h1.489v6h2.482V6zM7.552.113a.74.74 0 0 1 .675-.057l.106.054 7.31 4.5c.61.376.387 1.297-.285 1.383L15.254 6H.746C.032 6-.256 5.103.269 4.673l.084-.06 7.2-4.5zm.396 1.517L3.358 4.5h9.252L7.948 1.63z" />
    </g>
  );
};

export default withIcon(IconGovBuilding);
